export const defaultColors = ["#FF0000", "#FF7F00", "#FFFE55", "#67C84D", "#CC00FE", "#003DF4", "#3B00AD", "#6B0000", "#9B7A3E", "#040F93"];